import { createFileRoute, redirect } from '@tanstack/react-router'
import { authRepository } from '@/data/adapters/api/auth.api'
import { requireAuth } from '@/lib/auth-guard'
import { orgLandingTarget } from '@/lib/org-landing'

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    await requireAuth()

    // No membership: /welcome lets the user create their first store instead
    // of dead-ending here (redirecting to /login used to loop forever against
    // its guest-guard).
    const ws = await authRepository.getWorkspaces()
    throw redirect(orgLandingTarget(ws))
  },
})
